import fetch,{postFrom} from '../utils/fetch';

// 添加区域
export function saveAreaInfo(params) {
  return fetch({
      method: 'POST',
      url: 'area/saveAreaInfo',
      data:params
  })
}

export function getAreaInfoByFid(params) {
    return fetch({
        method: 'POST',
        url: 'area/getAreaInfoByFid',
        data:params
    })
}

// 获取区域列表
export function getArealist(params) {
    return fetch({
        method: 'POST',
        url: '/area/getAreaList',
        data:params
    })
}

// 更新区域
export function updateAreaInfo(params) {
    return fetch({
        method: 'POST',
        url: 'area/updateAreaInfo',
        data:params
    })
}
